var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45455 0H30V16.5H5.45455V0ZM17.7273 4.125C18.8123 4.125 19.8528 4.5596 20.62 5.33318C21.3872 6.10677 21.8182 7.15598 21.8182 8.25C21.8182 9.34402 21.3872 10.3932 20.62 11.1668C19.8528 11.9404 18.8123 12.375 17.7273 12.375C16.6423 12.375 15.6018 11.9404 14.8346 11.1668C14.0674 10.3932 13.6364 9.34402 13.6364 8.25C13.6364 7.15598 14.0674 6.10677 14.8346 5.33318C15.6018 4.5596 16.6423 4.125 17.7273 4.125ZM10.9091 2.75C10.9091 3.47935 10.6218 4.17882 10.1103 4.69454C9.59883 5.21027 8.90514 5.5 8.18182 5.5V11C8.90514 11 9.59883 11.2897 10.1103 11.8055C10.6218 12.3212 10.9091 13.0207 10.9091 13.75H24.5455C24.5455 13.0207 24.8328 12.3212 25.3443 11.8055C25.8557 11.2897 26.5494 11 27.2727 11V5.5C26.5494 5.5 25.8557 5.21027 25.3443 4.69454C24.8328 4.17882 24.5455 3.47935 24.5455 2.75H10.9091ZM0 5.5H2.72727V19.25H24.5455V22H0V5.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.c88f62da.svg";
export { ForwardRef as ReactComponent };